<template>
    <div>
        <Leftmenu />
        <Header />
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">
                <Backbutton />
               Редактировать аспект
            </div>
            <div class="content-inner">
                <div class="header-for-input">Наименование аспекта / трудовой операции</div>
                <input type="text" class="content-input input_width_50" v-model="aspect.name" />
                <!--- --- -->
                <div class="header-for-input">Вес аспекта</div>
                <input type="text" class="content-input input_width_50" v-model="aspect.value" />
                <!--- --- -->
                <div class="header-for-input">Пояснение к оценке</div>
                <textarea class="content-input input_width_50" style="height: 120px !important;" v-model="aspect.description"></textarea>
                <!--- --- -->
                <div class="header-for-input">Тип аспекта</div>
                <select class="content-input input_width_50" v-model="aspect.aspect_type_id">
                    <option value="0">Не выбрано</option>
                    <option v-for="aspect_type in ref_aspect_types" :key="aspect_type.id" :value="aspect_type.id">{{aspect_type.name}}</option>
                </select>
                <!--- --- -->
                <div class="btn_main_button" @click="update_aspect()">Сохранить</div>
                
            </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Backbutton from '@/components/elements/bacl-button.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'EditAspects',
    props: ['id_aspect'],
    components: {
        Leftmenu, Header, Backbutton, Success, Error
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            ref_aspect_types: {},
            aspect: {
                name: '',
                value: '',
                aspect_type_id: 0,
                description: '',
                corpstandart_type_of_work_id: this.id
            }
        }
    },
    methods: {
        refbook_aspect_types() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/refbook/aspect_types')
            .then(response => {
                this.ref_aspect_types = response.data.data
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        get_aspect() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/aspect/'+this.id_aspect)
            .then(response => {
                //this.operation_info = response.data.data
                //this.isSuccess = true
                this.aspect = response.data.data
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        },
        update_aspect() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/aspect/'+this.id_aspect, this.aspect)
            .then(response => {
                this.operation_info = response.data.data
                this.isSuccess = true
                loader.hide();
            })
            .catch(error => {
                loader.hide();
                this.error_text = error.response.status + ' ' + error.response.data.data;
                this.isError = true;
          });
        }
    },
    created() {   
        this.refbook_aspect_types()
        this.get_aspect()
    }
}
</script>

<style scoped src="../../../../assets/style/main.css"></style>
<style scoped src="../../../../assets/style/account.css"></style>
<style scoped src="../../../../assets/style/buttons.css"></style>